export const domains = {
  books: "https://books.selfpublishingtitans.com",
  coloring_book: "https://editor.selfpublishingtitans.com",
  main: "https://selfpublishingtitans.com",
}
